<template>
    <div
        v-if="totalPages > 1"
        class="tw:flex tw:items-center tw:justify-center tw:gap-2"
    >
        <button
            :disabled="currentPage === 1"
            class="tw:inline-flex tw:items-center tw:justify-center tw:h-6 tw:px-2 tw:text-xs tw:rounded tw:border tw:border-gray-200 tw:text-gray-500 tw:hover:border-gray-400 tw:disabled:opacity-40 tw:disabled:cursor-not-allowed tw:transition-all"
            aria-label="Primera página"
            title="Primera página"
            @click="changePage(1)"
        >
            <i class="material-icons tw:text-sm tw:leading-none">first_page</i>
        </button>

        <button
            :disabled="currentPage === 1"
            class="tw:inline-flex tw:items-center tw:justify-center tw:h-6 tw:px-2 tw:text-xs tw:rounded tw:border tw:border-gray-200 tw:text-gray-500 tw:hover:border-gray-400 tw:disabled:opacity-40 tw:disabled:cursor-not-allowed tw:transition-all"
            aria-label="Página anterior"
            title="Página anterior"
            @click="changePage(currentPage - 1)"
        >
            <i class="material-icons tw:text-sm tw:leading-none">chevron_left</i>
        </button>

        <button
            v-for="page in visiblePages"
            :key="page"
            class="tw:inline-flex tw:items-center tw:justify-center tw:h-6 tw:px-3 tw:text-xs tw:font-bold tw:rounded tw:border tw:transition-all"
            :class="page === currentPage
                ? 'tw:bg-black/90 tw:text-white tw:border-black/90'
                : 'tw:border-gray-200 tw:text-black/90 tw:hover:border-gray-400'"
            :aria-label="`Página ${page}`"
            :aria-current="page === currentPage ? 'page' : undefined"
            :title="`Página ${page}`"
            @click="changePage(page)"
        >
            {{ page }}
        </button>

        <button
            :disabled="currentPage === totalPages"
            class="tw:inline-flex tw:items-center tw:justify-center tw:h-6 tw:px-2 tw:text-xs tw:rounded tw:border tw:border-gray-200 tw:text-gray-500 tw:hover:border-gray-400 tw:disabled:opacity-40 tw:disabled:cursor-not-allowed tw:transition-all"
            aria-label="Página siguiente"
            title="Página siguiente"
            @click="changePage(currentPage + 1)"
        >
            <i class="material-icons tw:text-sm tw:leading-none">chevron_right</i>
        </button>

        <button
            :disabled="currentPage === totalPages"
            class="tw:inline-flex tw:items-center tw:justify-center tw:h-6 tw:px-2 tw:text-xs tw:rounded tw:border tw:border-gray-200 tw:text-gray-500 tw:hover:border-gray-400 tw:disabled:opacity-40 tw:disabled:cursor-not-allowed tw:transition-all"
            aria-label="Última página"
            title="Última página"
            @click="changePage(totalPages)"
        >
            <i class="material-icons tw:text-sm tw:leading-none">last_page</i>
        </button>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { usePagination } from '@/composables/front/common/usePagination';

    const props = defineProps({
        value: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        perPage: {
            type: Number,
            default: 10
        }
    });

    const emit = defineEmits(['input']);
    const currentPageRef = computed(() => props.value   || 1);
    const totalRef       = computed(() => props.total   || 0);
    const perPageRef     = computed(() => props.perPage || 10);

    const {
        totalPages,
        currentPage,
        visiblePages,
        resolvePage,
    } = usePagination(currentPageRef, totalRef, perPageRef);

    function changePage(page) {
        const safe = resolvePage(page);
        if (safe === null) return;
        emit('input', safe);
    }
</script>
